<form #resetpasswordForm="ngForm" name="resetpasswordForm" class="mx-0 mt-4 mb-0" (ngSubmit)="OnSubmit()" autocomplete="off">
  <div class="fieldset" *ngIf="!this.code">
    <label for="oldPass" class="legend">Old Password</label>
    <input type="password" name="oldPass" id="oldPass" class="text-field" [disabled]="isLoading" [(ngModel)]="oldPassword" #oldPass required>
  </div>
  <div class="fieldset">
    <label for="Password" class="legend">New Password</label>
    <input type="password" name="Password" id="Password" class="text-field" [disabled]="isLoading" [(ngModel)]="newPassword" #Password required>
  </div>
  <div class="fieldset">
    <label for="ConfirmPassword" class="legend">Confirm New Password</label>
    <input type="password" name="ConfirmPassword" id="ConfirmPassword" class="text-field" [disabled]="isLoading" [(ngModel)]="newPasswordConfirm" #ConfirmPassword required>
  </div>
  <button *ngIf="!isLoading; else resettingPassword" type="submit" class="btn" [disabled]="resetpasswordForm.invalid">Reset password</button>
  <ng-template #resettingPassword>
    <button class="btn btn--loading" type="button">Resetting your password...</button>
  </ng-template>
</form>
